import { DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

interface DeleteDialogProps {
  isOpen: boolean;
  onAbort: () => void;
  onConfirm: () => void;
  onClose: () => void;
  text?: string;
  labelOk?: string;
}

const DeleteDialog = ({
  isOpen,
  onAbort,
  onClose,
  onConfirm,
  labelOk = 'Conferma Eliminazione',
  text = 'Sei sicuro di voler eliminare il record?',
}: DeleteDialogProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="close-modal"
      aria-describedby="close-modal"
      fullWidth
    >
      <PmiDialogTitle id="close-modal-title" backgroundColor="primary" color="white">
        Elimina
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>{text}</DialogContent>
      <DialogActions>
        <PmiButton variant="contained" color="cdmBrand" type="button" onClick={onConfirm}>
          {labelOk}
        </PmiButton>
        <PmiButton variant="outlined" color="primary" type="button" onClick={onAbort}>
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

DeleteDialog.displayName = 'Delete dialog';

export default DeleteDialog;
